import layout from '../layout/index.vue'
import blank from '../layout/blank.vue'
export default {
    path: '/supplier',
    name: 'supplier',
    redirect: '/supplier/index',
    meta: {
        type: 'supplier'
    },
    component: layout,
    children: [
        {
            path: 'index',
            name: 'supplier-index',
            meta: {
                type: 'supplier',
                title: '系统首页',
                icon: 'el-icon-s-home',
                hidden: false
            },
            component: () => import('../views/supplier/home/index.vue')
        },
        {
            path: 'selection-mall',
            name: 'supplier-selection-mall',
            meta: {
                type: 'supplier',
                title: '选品中心',
                icon: 'dw-icon-basket',
                hidden: false
            },
            component: blank,
            redirect: '/supplier/selection-mall/list',
            children: [
                {
                    path: 'list',
                    name: 'supplier-selection-mall-list',
                    meta: {
                        type: 'supplier',
                        title: '商品列表',
                        hidden: true
                    },
                    component: () => import('../views/supplier/selection-mall/list.vue'),
                },
                {
                    path: 'detail',
                    name: 'supplier-selection-mall-detail',
                    meta: {
                        type: 'supplier',
                        title: '商品详情',
                        hidden: true
                    },
                    component: () => import('../views/supplier/selection-mall/detail.vue'),
                }
            ]
        },
        {
            path: 'goods',
            name: 'supplier-goods',
            meta: {
                type: 'supplier',
                title: '商品管理',
                icon: 'el-icon-s-goods',
                hidden: false
            },
            component: blank,
            redirect: '/supplier/goods/list',
            children: [
                {
                    path: 'list',
                    name: 'supplier-goods-list',
                    meta: {
                        type: 'supplier',
                        title: '商品列表',
                        hidden: false
                    },
                    component: () => import('../views/supplier/goods/list.vue'),
                },
                {
                    path: 'add',
                    name: 'supplier-goods-add',
                    meta: {
                        type: 'supplier',
                        title: '添加商品',
                        hidden: false
                    },
                    component: () => import('../views/supplier/goods/add.vue'),
                },
                {
                    path: 'detail',
                    name: 'supplier-goods-detail',
                    meta: {
                        type: 'supplier',
                        title: '商品详情',
                        hidden: true
                    },
                    component: () => import('../views/supplier/goods/detail.vue'),
                },
                {
                    path: 'edit',
                    name: 'supplier-goods-edit',
                    meta: {
                        type: 'supplier',
                        title: '编辑商品',
                        hidden: true
                    },
                    component: () => import('../views/supplier/goods/edit.vue'),
                },
            ]
        },
        {
            path: 'order',
            name: 'supplier-order',
            meta: {
                type: 'supplier',
                title: '订单管理',
                icon: 'el-icon-s-order',
                hidden: false
            },
            component: blank,
            redirect: '/supplier/order/list',
            children: [
                // {
                //     path: 'list',
                //     name: 'supplier-order-list',
                //     meta: {
                //         type: 'supplier',
                //         title: '订单列表(旧)',
                //         icon: '',
                //         hidden: false
                //     },
                //     component: () => import('../views/supplier/order/list.vue'),
                // },
                {
                    path: 'list-lock',
                    name: 'supplier-order-list-lock',
                    meta: {
                        type: 'supplier',
                        title: '锁仓列表',
                        icon: '',
                        hidden: false
                    },
                    component: () => import('../views/supplier/order/list-lock.vue'),
                },
                {
                    path: 'list-order',
                    name: 'supplier-order-list-order',
                    meta: {
                        type: 'supplier',
                        title: '下单列表',
                        icon: '',
                        hidden: false
                    },
                    component: () => import('../views/supplier/order/list-order.vue'),
                },
                {
                    path: 'list-clear',
                    name: 'supplier-order-list-clear',
                    meta: {
                        type: 'supplier',
                        title: '清算列表',
                        icon: '',
                        hidden: false
                    },
                    component: () => import('../views/supplier/order/list-clear.vue'),
                },
                {
                    path: 'detail-lock',
                    name: 'supplier-order-detail-lock',
                    meta: {
                        type: 'supplier',
                        title: '锁仓详情',
                        icon: '',
                        hidden: true
                    },
                    component: () => import('../views/supplier/order/detail-lock.vue'),
                },
                {
                    path: 'detail-order',
                    name: 'supplier-order-detail-order',
                    meta: {
                        type: 'supplier',
                        title: '下单详情',
                        icon: '',
                        hidden: true
                    },
                    component: () => import('../views/supplier/order/detail-order.vue'),
                },
                {
                    path: 'detail-clear',
                    name: 'supplier-order-detail-clear',
                    meta: {
                        type: 'supplier',
                        title: '清算详情',
                        icon: '',
                        hidden: true
                    },
                    component: () => import('../views/supplier/order/detail-clear.vue'),
                },
                {
                    path: 'detail',
                    name: 'supplier-order-detail',
                    meta: {
                        type: 'supplier',
                        title: '订单详情',
                        icon: '',
                        hidden: true
                    },
                    component: () => import('../views/supplier/order/detail.vue'),
                },
                {
                    path: 'liquidation',
                    name: 'supplier-order-liquidation',
                    meta: {
                        type: 'supplier',
                        title: '清算详情',
                        icon: '',
                        hidden: true
                    },
                    component: () => import('../views/supplier/order/liquidation.vue'),
                }
            ]
        },
        {
            path: 'stock',
            name: 'supplier-stock',
            meta: {
                type: 'supplier',
                title: '库存管理',
                icon: 'el-icon-s-cooperation',
                hidden: false
            },
            component: blank,
            redirect: '/supplier/stock/list',
            children: [
                {
                    path: 'list',
                    name: 'supplier-stock-list',
                    meta: {
                        type: 'supplier',
                        title: '库存列表',
                        icon: '',
                        hidden: false
                    },
                    component: () => import('../views/supplier/stock/list.vue'),
                },
                {
                    path: 'edit',
                    name: 'supplier-stock-edit',
                    meta: {
                        type: 'supplier',
                        title: '修改库存',
                        icon: '',
                        hidden: true
                    },
                    component: () => import('../views/supplier/stock/edit.vue'),
                }
            ]
        },
        {
            path: 'setting',
            name: 'supplier-setting',
            meta: {
                type: 'supplier',
                title: '个人设置',
                icon: 'el-icon-s-tools',
                hidden: false
            },
            component: () => import('../views/supplier/setting/index.vue')
        },
    ]
}